import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { IMessage } from 'src/app/models/message.model';
import { ProfileModel } from 'src/app/models/profile.model';
import { DataService } from 'src/app/services/data/data.service';
import { ExternalService } from 'src/app/services/external/external.service';


@Component({
    templateUrl: './message-composer.component.html',
    styleUrls: ['./message-composer.component.scss'],
    selector: 'message-composer',
})

export class MessageComposerComponent implements OnInit {
    form: UntypedFormGroup;
    loading = false;

    message:IMessage = {
      body:''
    };

    @Input()
    type:string;

    @Input()
    tourneeKey:string;

    @Input()
    producerKey:string;

    @Input()
    sender:ProfileModel;

    @Input()
    marketKey:string;

    @Input()
    itemKey:string;

    @Input()
    orderKey:string;

    @Input()
    public onMessageSent = (basket) => {}

    @Output() messageSent = new EventEmitter<IMessage>();

    constructor(private externalService:ExternalService,private formBuilder: UntypedFormBuilder, 
        private toastCtrl: ToastController,
        private dataService:DataService,
        private translateService:TranslateService) {
        this.setForm();
    }

    setForm(){
        this.form = this.formBuilder.group({
          subject:[null, Validators.compose([Validators.required])],
          // sender:[null, Validators.compose([Validators.required])],
          // signature:[null, Validators.compose([Validators.required])],
          body:[null, Validators.compose([Validators.required])],
          recipientType:[null, Validators.compose([Validators.required])]
        });
    }
    patchForm(){
      this.form.patchValue(this.message);
    }
  
    ionViewWillEnter() {

    }

    ngOnInit(){

    }
    async presentToast(message: string): Promise<void> {
        const toast = await this.toastCtrl.create({
          message: message,
          duration: 15000,
          buttons: [
            {
              side: "end",
              icon: "close-circle-outline",
              role: "cancel",
              handler: () => {
                console.log("dismiss toast");
                //toast.dismiss();
              }
            }
          ],
          position: "bottom"
        });
        toast.present();
      }

    async submit(): Promise<void> {
        const item = this.form.getRawValue();
        if (!this.form.valid && this.message.body && this.message.body !== '') {
          this.presentToast(this.translateService.instant("alerts.invalidForm"));
        } else {
          this.loading = true;
          this.form.disable();
          this.message.recipientType = item.recipientType;
          this.message.body = item.body;
          this.message.subject = item.subject;
          this.message.tourneeKey = this.tourneeKey || null;
          this.message.producerKey = this.producerKey || null;
          this.message.marketKey = this.marketKey || null;
          this.message.itemKey = this.itemKey;
          // this.message.signature = item.signature;
          this.message.dateTime = Date();
          this.message.type = this.type;
          this.save(this.message);
        }
      }
    
    
      async save(item): Promise<void> {
        try {
            this.dataService.createMessage(item).then(_ => {
                this.loading = false;
                this.form.enable();
                this.presentToast(this.translateService.instant("message.Sent"));
                this.onMessageSent(item);
                this.messageSent.emit(item);
            });
        } catch (error) {
          this.loading = false;
          this.form.enable();
          console.log(error);
          this.presentToast(this.translateService.instant("errors.save") + ": " + error);
        }
      }
    
  }